import React, { useEffect, useState } from "react";

import axios from "axios";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { formUpdateStatus } from "../../redux/slice/formUpdateSlice";
import {
  attendanceLogListAction,
  walletLogListAction,
} from "../../network/store/action/UserResponseAction";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
} from "reactstrap";
import WalletLogItem from "./wallet-log-item";

function UserWalletLog() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const userId = location.state != null ? location.state.userId : "";

  // list of items
  const [resultList, setResultList] = useState([]);
  const showRequestForm = useSelector(formUpdateStatus);
  const [userList, setUserList] = useState([]);
  // progress Dialog
  const [isLoading, setIsLoading] = useState(false);

  const [filterList, setFilterList] = useState([]);
  const [searchVal, setSearchVal] = useState("");

  const [branches, setBranchList] = useState([]);
  const [filterOptions, setfilterOptions] = useState({
    userId: userId,
  });

  useEffect(() => {
    loadData();
  }, []);


  useEffect(() => {
    loadData();
  }, [filterOptions]);

  const handleChanges = (e) => {
    if (e.target.name === "storeId") {
      branches.findIndex((obj) => obj.id === e.target.value);
      setfilterOptions({
        ...filterOptions,
        storeId: e.target.value,
        userId: "",
      });
    } else {
      setfilterOptions({ ...filterOptions, [e.target.name]: e.target.value });
    }
  };
  const loadData = async () => {
    await dispatch(
      walletLogListAction(
        {
          userId: filterOptions.userId,
        },
        dispatch
      )
    ).then((reponse) => {
      setFilterList([]);

      if (reponse.result) {
        setResultList(reponse.result);
      } else {
        setResultList([]);
      }
    });
  };



  return (
    <main className="container-fluid dashboard">
      <div className="row m-3">
        <div className="col-md-3">
          <div className="form-group">
            <label>Wallet Log</label>
      
          </div>
        </div>
       

        <div className="col-md-12 card-1 table-responsive">
          <table className="table table-striped table-bordered border-sm  mt-2 align-middle">
            <thead className="thead-dark">
              <tr>
                <th scope="col">ID</th>
                <th scope="col">TYPE</th>
                <th scope="col">Amount</th>
                <th scope="col">Notes</th>
                <th scope="col">Date</th>
              </tr>
            </thead>

            {searchVal === "" && resultList && resultList.length > 0 ? (
              <tbody>
                {resultList.map((item, i) => {
                  return <WalletLogItem item={item} key={item.id} />;
                })}
              </tbody>
            ) : filterList.length > 0 ? (
              <tbody>
                {filterList.map((item, i) => {
                  return <WalletLogItem item={item} key={item.id} />;
                })}
              </tbody>
            ) : (
              <p>No Data found</p>
            )}
          </table>
        </div>
      </div>
    </main>
  );
}

export default UserWalletLog;
